module.exports = __webpack_public_path__ + "static/media/roadAssist.1e6dab83.svg";